function updateTotalSize(event) {
	var target = event.target.closest("input[type=file]");

	if (target) {
		var files = target.files,
			fileSize = 0;
		for (var x in files) {
			if (Number.isInteger(files[x].size)) {
				fileSize += parseFloat(((files[x].size / 1024) / 1024)); // MB
			}
		}
	
		var fileSizeContainer = document.querySelector(".filesize-notice");
		if (!fileSizeContainer) {
			fileSizeContainer = document.createElement("div");
			target.parentElement.append(fileSizeContainer);
			fileSizeContainer.classList.add("filesize-notice");
		}
		if (fileSize > 25) {
			fileSizeContainer.innerHTML = "Your are over the 25MB size limit: " + fileSize.toFixed(2) + "MB";
			fileSizeContainer.classList.add("limit-exceeded");
		} else {
			fileSizeContainer.innerHTML = "Selected file size: " + fileSize.toFixed(2) + "MB";
			fileSizeContainer.classList.remove("limit-exceeded");
		}
	}
}

document.addEventListener("change", updateTotalSize);